const PATHS = {
  ROOT: '/',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  HOME: '/home',
  DOCUMENTS: '/home/documents',
  DO_VOICE: '/home/voice',
  PULSE: '/home/pulse',
  SCHEDULES: '/home/schedules',
  TRIGGERS: '/home/triggers',
  SKILLS: '/home/skills',
  BUILD: '/home/build',
  CONNECTIONS: '/home/connections',
  SETTINGS: '/settings',
  // Where hosted OAuth returns the browser. Unprotected and inert — see
  // IntegrationsCallbackPage.
  INTEGRATIONS_CALLBACK: '/integrations/callback',
}

/** React Router pattern for `useMatch` / `<Route path={…} />` */
export const HOME_THREAD_ROUTE_PATTERN = '/home/thread/:threadId'

/** Deep link for a home chat thread (SaaS: shareable, refresh-safe). */
export function buildHomeThreadPath(threadId) {
  return `/home/thread/${encodeURIComponent(threadId)}`
}

/** @param {string} sectionId */
export function buildSettingsSectionPath(sectionId) {
  return `${PATHS.SETTINGS}/${encodeURIComponent(sectionId)}`
}

export default PATHS
